module.exports = __webpack_public_path__ + "img/gpbplock.88449ea4.jpg";